var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_343",
    "data-name": "Gruppe 343",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_514",
    "data-name": "Pfad 514",
    d: "M2,2H21.636L28,7.339V38H2ZM0,0V40H30V6.405L22.364,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_236",
    "data-name": "Rechteck 236",
    width: 10,
    height: 2,
    transform: "translate(5 6)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_237",
    "data-name": "Rechteck 237",
    width: 10,
    height: 2,
    transform: "translate(5 12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_515",
    "data-name": "Pfad 515",
    d: "M15,34.794,10.842,28.6,8,31.409,4.332,27.748l1.413-1.414L8,28.591l3.153-3.11L15,31.206l3.659-5.451,6.786,3.37-.889,1.791-5.214-2.589Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Reports_icon.d26a17c52950bfbdf5dd252646b54b0b.svg";